<i18n>
{
  "fr": {
    "specific-indicators": "Indicateurs spécifiques",
    "all-indicators": "Tous les indicateurs"
  },
  "en": {
    "specific-indicators": "Specific indicators",
    "all-indicators": "All indicators"
  }
}
</i18n>

<template>
  <b-switch
    class="specific-switch"
    :rounded="isRounded"
    :outlined="isOutlined"
    :size="size"
    :aria-labelledby="switchLabel"
    @input="toggleSwitch"
    >{{ switchLabel }}</b-switch
  >
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'is-large'
    }
  },
  data() {
    return {
      isRounded: false,
      isOutlined: false,
      showSpecificOnly: false,
      isFullPage: true
    }
  },
  computed: {
    switchLabel() {
      const label = this.showSpecificOnly ? this.$t('specific-indicators') : this.$t('all-indicators')
      return label
    }
  },
  methods: {
    toggleSwitch(e) {
      this.$emit('toggle-specific-indicators', e)
      if (e) {
        this.showSpecificOnly = true
      } else {
        this.showSpecificOnly = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/specific-switch';
</style>
